import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../../css/svg.css';

const OhioMap = ({ onZoneClick }) => {
	const [selectedZone, setSelectedZone] = useState(null);

	const handleZoneClick = (zoneId) => {
		setSelectedZone(zoneId);
		if (onZoneClick) {
			onZoneClick(zoneId);
		}
		console.log('Zone Clicked: %s', zoneId);
	};

	return (
		<svg id='ohio' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000' className='map'>
			<polygon
				id='OH_ZS'
				points='787.07 531.2 782.73 555.26 745.57 621.73 711.49 630.21 695.58 647.64 662.13 688.36 637.64 710.92 623.45 740.6 619.42 769.33 600.79 793.52 580.16 798.38 568.39 786.08 544.73 762.48 524 749.23 499.77 759.75 385.4 747.71 356.92 712.54 332.85 692.91 296.05 689.03 285.06 697.93 285.21 544.91 787.07 531.2'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'OH_ZS' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('OH_ZS')}
			/>
			<polygon
				id='OH_ZN'
				points='787.07 531.2 794.83 488.16 802.42 425.61 812.92 422.69 798.79 197.3 752.64 220.27 716.42 239.58 681.35 267.06 645.71 290.45 606.4 291.34 570.28 309.66 546.83 303.17 510.51 285.27 485.7 272.6 449.63 261.77 285.49 273.64 285.21 544.91 787.07 531.2'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'OH_ZN' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('OH_ZN')}
			/>
			<rect
				x='518.79'
				y='596.92'
				width='60.55'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M518.18,636.45l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M552.67,633.27c2.2,1.48,5.23,2.58,8.61,2.58,4.55,0,8.74-2.72,8.74-7.59,0-3.01-1.69-5.24-5.92-7.56-5.16-2.79-8.05-6.03-8.05-10.37,0-7.24,6.22-11.87,13.65-11.87,3.95,0,6.89,1.15,8.28,2.1l-1.77,4.07c-1.27-.76-3.8-1.93-7.02-1.9-4.99,0-8.01,3.29-8.02,6.61,0,3.28,2.05,5.15,6.28,7.5,4.98,2.67,7.71,5.86,7.71,10.82,0,6.99-5.49,12.5-14.59,12.5-4.04,0-8.04-1.32-9.73-2.81l1.8-4.07Z'
				className='shape'
			/>
			<rect
				x='462.96'
				y='386.47'
				width='72.08'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M462.35,425.99l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M496.21,429.07l7.69-40.44h5.45l9.26,22.9c1.79,4.6,2.7,7.8,3.55,11.28l.13-.06c.22-3.63.64-6.99,1.69-12.66l4.08-21.45h4.71l-7.69,40.44h-4.92l-9.22-22.86c-1.97-5-2.87-7.84-3.75-11.67l-.18.06c-.45,3.78-1.09,7.82-2.12,13.32l-3.99,21.14h-4.69Z'
				className='shape'
			/>
			<polygon
				points='499.45 483.66 499.56 487.98 504.11 487.98 499.63 490.65 499.74 494.98 496.86 492.31 492.38 494.98 495.08 490.65 492.21 487.98 496.75 487.98 499.45 483.66'
				className='shape'
			/>
			<rect x='506.59' y='465.56' width='120.4' height='20' fill='none' className='shape' />
			<path
				d='M518.52,482.08c-.91.41-2.38.77-4.2.77-4.07,0-6.57-2.59-6.57-6.72,0-3.04,1.23-5.95,3.46-7.79,1.67-1.41,3.73-2.17,6.1-2.17,1.8,0,3.09.45,3.51.78l-.64,1.61c-.6-.36-1.74-.67-3.18-.67-1.69,0-3.39.66-4.63,1.81-1.52,1.42-2.48,3.7-2.48,6.16,0,2.89,1.33,5.28,4.92,5.28,1.22,0,2.56-.24,3.46-.69l.26,1.63Z'
				className='shape'
			/>
			<path
				d='M533.99,475.56c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM525.06,478.02c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.74,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path d='M537.81,482.6l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M557.04,471l-1.56,8.23c-.25,1.29-.41,2.42-.52,3.38h-1.8l.3-2.19h-.05c-1.03,1.51-2.56,2.46-4.1,2.46s-3.07-.72-3.07-3.36c0-.56.07-1.18.22-1.95l1.25-6.56h1.99l-1.23,6.47c-.12.64-.2,1.2-.2,1.7,0,1.2.49,2.02,1.86,2.02,1.45,0,3.3-1.69,3.78-4.24l1.13-5.95h1.99Z'
				className='shape'
			/>
			<path
				d='M560.77,482.6l1.54-8.23c.25-1.29.41-2.42.54-3.38h1.75l-.31,2.18h.06c1.09-1.62,2.55-2.44,4.09-2.44,1.77,0,2.63,1.12,2.71,2.59,1.04-1.68,2.52-2.56,4.26-2.59,1.34,0,2.82.86,2.82,3.04,0,.54-.07,1.32-.19,1.97l-1.3,6.85h-1.94l1.25-6.69c.08-.45.17-1.04.17-1.52,0-1.23-.46-2.02-1.75-2.02-1.45,0-3.17,1.67-3.65,4.27l-1.11,5.95h-1.94l1.3-6.81c.1-.52.16-.96.16-1.42,0-.98-.27-1.99-1.74-1.99s-3.26,1.92-3.71,4.38l-1.07,5.83h-1.94Z'
				className='shape'
			/>
			<path
				d='M587.7,465.56l-1.53,7.53h.05c1.03-1.55,2.52-2.36,4.08-2.36,2.54,0,3.52,2.1,3.52,4.16,0,3.57-2.58,7.98-7.23,7.98-2.04,0-3.58-.85-3.58-3,0-.57.1-1.25.2-1.8l2.5-12.51h1.99ZM585.18,478.12c-.08.39-.15.85-.14,1.47.01,1.1.64,1.71,1.88,1.71,3.01,0,4.82-3.57,4.82-6.15,0-1.44-.63-2.77-2.22-2.77-1.71,0-3.5,1.78-4.08,4.5l-.26,1.23Z'
				className='shape'
			/>
			<path
				d='M608.93,471l-1.57,8.23c-.24,1.29-.41,2.42-.52,3.38h-1.8l.3-2.19h-.05c-1.04,1.51-2.56,2.46-4.1,2.46s-3.07-.72-3.07-3.36c0-.56.07-1.18.22-1.95l1.25-6.56h1.99l-1.23,6.47c-.12.64-.2,1.2-.2,1.7,0,1.2.49,2.02,1.85,2.02,1.45,0,3.3-1.69,3.78-4.24l1.13-5.95h1.99Z'
				className='shape'
			/>
			<path
				d='M612.75,480.59c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.89,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.85.56,1.37,1.59,1.95,1.29.73,2.17,1.75,2.17,3.05,0,2.44-1.98,3.82-4.43,3.82-1.25,0-2.36-.39-2.89-.79l.57-1.47Z'
				className='shape'
			/>
			<polygon
				points='638.53 295.27 638.64 299.6 643.18 299.6 638.7 302.27 638.81 306.59 635.94 303.92 631.46 306.59 634.16 302.27 631.28 299.6 635.83 299.6 638.53 295.27'
				className='shape'
			/>
			<rect x='637.89' y='309.11' width='114.66' height='20' fill='none' className='shape' />
			<path
				d='M649.82,325.63c-.91.41-2.38.77-4.2.77-4.07,0-6.56-2.59-6.56-6.72,0-3.04,1.23-5.95,3.45-7.79,1.67-1.41,3.73-2.17,6.1-2.17,1.8,0,3.09.45,3.51.78l-.64,1.61c-.6-.36-1.74-.67-3.18-.67-1.69,0-3.39.66-4.63,1.81-1.52,1.42-2.48,3.7-2.48,6.16,0,2.89,1.33,5.28,4.92,5.28,1.22,0,2.56-.24,3.46-.69l.27,1.63Z'
				className='shape'
			/>
			<path d='M654.32,326.15l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M670.61,325.48c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.8l.29,1.48ZM668.4,315.83c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.76-1.48Z'
				className='shape'
			/>
			<path
				d='M678.18,314.54l1,6.61c.17,1.32.33,2.21.37,2.85h.07c.25-.62.57-1.38,1.24-2.7l3.54-6.76h2.18l-6.46,11.61h-1.96l-2.01-11.61h2.03Z'
				className='shape'
			/>
			<path
				d='M697.12,325.48c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.43,3.85-7.73,3.77-.1.5-.03,1.59.24,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.8l.29,1.48ZM694.92,315.83c-1.89,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path d='M702.05,326.15l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M717.66,326.15c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.5,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.03-8.3,1.11,0,2.33.19,3.13.44l-1.19,6.05c-.38,2.02-.54,4.1-.49,5.38h-1.86ZM718.96,316.03c-.28-.09-.71-.17-1.38-.17-3,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M724.97,326.15l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.93.79,2.93,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M752.55,309.11l-2.55,13.36c-.22,1.2-.42,2.56-.49,3.68h-1.82l.31-2.3h-.05c-1.06,1.65-2.52,2.56-4.19,2.56-2.24,0-3.47-1.84-3.47-4.22,0-4.13,3.07-7.91,7.18-7.91.73,0,1.55.16,2.05.4l1.04-5.57h1.98ZM749.21,316.36c-.4-.27-1.07-.49-1.9-.49-2.79,0-4.95,2.97-4.95,6.05,0,1.41.48,2.86,2.19,2.86,1.53,0,3.38-1.75,3.88-4.36l.78-4.06Z'
				className='shape'
			/>
			<polygon
				points='324.94 675.04 325.05 679.36 329.59 679.36 325.12 682.03 325.22 686.36 322.35 683.68 317.87 686.36 320.57 682.03 317.69 679.36 322.24 679.36 324.94 675.04'
				className='shape'
			/>
			<rect x='332.08' y='656.94' width='122.86' height='20' fill='none' className='shape' />
			<path
				d='M344.01,673.46c-.91.41-2.38.77-4.2.77-4.07,0-6.57-2.59-6.57-6.72,0-3.04,1.23-5.95,3.46-7.79,1.67-1.41,3.73-2.17,6.1-2.17,1.8,0,3.09.45,3.51.78l-.64,1.61c-.6-.36-1.74-.67-3.18-.67-1.69,0-3.39.66-4.63,1.81-1.52,1.42-2.48,3.7-2.48,6.16,0,2.89,1.33,5.28,4.92,5.28,1.22,0,2.56-.24,3.46-.69l.26,1.63Z'
				className='shape'
			/>
			<path
				d='M348.48,673.98l2.22-11.61h1.99l-2.22,11.61h-1.99ZM351.06,659.13c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M356.4,673.98l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.93.79,2.93,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M379.62,673.52c-.59.29-1.79.71-3.37.71-2.99,0-4.46-2.02-4.46-4.49,0-3.96,2.95-7.63,7.12-7.63,1.08,0,2.06.32,2.41.53l-.57,1.58c-.46-.22-1.1-.44-1.97-.44-3.01,0-4.92,2.97-4.92,5.71,0,1.89.99,3.1,2.89,3.1,1.18,0,2.09-.36,2.68-.65l.19,1.57Z'
				className='shape'
			/>
			<path
				d='M384.24,673.98l2.22-11.61h1.99l-2.22,11.61h-1.99ZM386.82,659.13c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M392.16,673.98l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.3-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M407.4,673.98l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M430.33,673.98c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.97-8.3,8.03-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.1-.49,5.38h-1.86ZM431.62,663.86c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M442.81,659.26l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.12.65-.23,1.25-.23,1.85,0,.69.33,1.12,1.1,1.12.36,0,.68-.03.94-.09l-.1,1.57c-.35.14-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.08-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M447.55,673.98l2.22-11.61h1.99l-2.22,11.61h-1.99ZM450.13,659.13c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<polygon
				points='445.97 266.11 446.07 270.43 450.62 270.43 446.14 273.1 446.25 277.43 443.37 274.76 438.89 277.43 441.59 273.1 438.72 270.43 443.26 270.43 445.97 266.11'
				className='shape'
			/>
			<rect x='360.33' y='277.18' width='79.67' height='20' fill='none' className='shape' />
			<path
				d='M366.62,279.77h-4.73l.34-1.73h11.46l-.34,1.73h-4.75l-2.74,14.45h-1.99l2.74-14.45Z'
				className='shape'
			/>
			<path
				d='M384.54,287.18c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.15-4.53-4.77,0-3.84,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM375.61,289.64c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.74,0-1.36-.62-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path d='M388.36,294.22l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M404.64,293.55c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.43,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.8l.29,1.48ZM402.44,283.9c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.76-1.48Z'
				className='shape'
			/>
			<path
				d='M421.94,277.18l-2.55,13.36c-.22,1.2-.42,2.56-.49,3.68h-1.82l.31-2.3h-.05c-1.06,1.65-2.52,2.56-4.19,2.56-2.24,0-3.47-1.84-3.47-4.22,0-4.13,3.07-7.91,7.18-7.91.73,0,1.55.16,2.05.4l1.04-5.57h1.98ZM418.59,284.43c-.4-.27-1.07-.49-1.9-.49-2.79,0-4.95,2.97-4.95,6.05,0,1.4.48,2.86,2.19,2.86,1.53,0,3.38-1.75,3.88-4.36l.78-4.06Z'
				className='shape'
			/>
			<path
				d='M435.75,287.18c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.15-4.53-4.77,0-3.84,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM426.83,289.64c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.74,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<polygon
				points='362.21 626.69 362.32 631.01 366.86 631.01 362.38 633.68 362.49 638 359.62 635.33 355.14 638 357.84 633.68 354.96 631.01 359.51 631.01 362.21 626.69'
				className='shape'
			/>
			<rect x='369.35' y='608.59' width='85.59' height='20' fill='none' className='shape' />
			<path
				d='M373.13,609.67c1.24-.22,2.6-.32,4.02-.32,2.7,0,4.76.77,5.95,2.15.87.9,1.51,2.35,1.52,4.39,0,2.93-1.17,5.83-3.25,7.6-1.87,1.57-4.23,2.25-7.33,2.25-1.41,0-2.87-.08-3.92-.2l3.01-15.87ZM372.41,623.98c.73.1,1.49.11,2.09.11,2.57,0,4.44-.76,5.79-2.15,1.46-1.49,2.21-3.69,2.21-5.97,0-2.86-1.4-5-5.43-5-.72,0-1.63.04-2.21.17l-2.44,12.84Z'
				className='shape'
			/>
			<path
				d='M395.92,625.63c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.97-8.3,8.03-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.1-.49,5.38h-1.86ZM397.21,615.51c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M405.68,614.02l1.15,6.24c.26,1.34.41,2.19.53,3.06h.06c.3-.74.65-1.56,1.23-2.84l2.97-6.46h2.12l-4.36,8.82c-1.24,2.52-2.42,4.55-4,6.11-1.3,1.31-2.71,1.86-3.38,2l-.49-1.71c.5-.17,1.34-.5,2.13-1.12.79-.61,1.62-1.54,2.25-2.68.1-.19.09-.33.06-.53l-2.33-10.9h2.07Z'
				className='shape'
			/>
			<path
				d='M421.38,610.9l-.6,3.12h2.78l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.12,1.1,1.12.36,0,.68-.03.94-.09l-.1,1.57c-.35.14-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.08-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M437.16,618.59c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM428.23,621.05c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.74,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M440.97,625.63l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.93.79,2.93,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<polygon
				points='596.09 660.64 596.2 664.96 600.75 664.96 596.27 667.64 596.37 671.96 593.5 669.29 589.02 671.96 591.72 667.64 588.84 664.96 593.39 664.96 596.09 660.64'
				className='shape'
			/>
			<rect x='601.39' y='642.03' width='82.37' height='20' fill='none' className='shape' />
			<path
				d='M605.42,653.96l-2.57,5.12h-2.1l8.36-16.18h2.35l2.24,16.18h-2.04l-.65-5.12h-5.58ZM610.85,652.37l-.63-4.67c-.09-.84-.21-2.03-.29-2.98h-.06c-.43.96-.83,1.97-1.32,2.95l-2.41,4.7h4.71Z'
				className='shape'
			/>
			<path
				d='M623.22,644.35l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.13,1.1,1.13.36,0,.68-.03.94-.09l-.1,1.57c-.35.14-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.08-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M627.96,659.07l3.24-17.04h1.99l-1.45,7.48h.05c1-1.41,2.4-2.31,4.15-2.31,1.32,0,2.89.8,2.89,3.11,0,.62-.08,1.38-.19,1.96l-1.29,6.8h-1.99l1.27-6.71c.08-.42.16-.96.16-1.6,0-1.07-.51-1.91-1.8-1.91-1.54,0-3.47,1.8-3.95,4.4l-1.08,5.82h-1.99Z'
				className='shape'
			/>
			<path
				d='M651.57,658.41c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.24,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.8l.29,1.48ZM649.37,648.75c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.76-1.48Z'
				className='shape'
			/>
			<path
				d='M656.5,659.07l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.93.79,2.93,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.48,0-1.17-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M671.83,657.06c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.89,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.86.56,1.37,1.6,1.96,1.29.73,2.17,1.75,2.17,3.05,0,2.44-1.98,3.83-4.43,3.83-1.25,0-2.36-.39-2.89-.8l.57-1.47Z'
				className='shape'
			/>
		</svg>
	);
};

OhioMap.propTypes = {
	onZoneClick: PropTypes.func.isRequired,
	selectedZone: PropTypes.string,
};

export default OhioMap;
